import { getUserEmailFromCookies, getUserIPAddressFromCookies } from './getUserDetailsUtil'
import {
  CLOUDINARY_API_KEY,
  CLOUDINARY_NAME,
} from '../../../constants/images/cloudinary'
import { KLAVIYO_PUBLIC_API_KEY } from '../../../constants/index'
import { headers } from './headers'
import cloudinary from 'cloudinary-core'
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  api_key: CLOUDINARY_API_KEY,
})

export const trackBikePageViewed = (
  bikeId,
  year,
  make,
  model,
  city,
  state,
  url,
  photoUrlId,
  dailyPrice,
  ownerName
) => {
  const bikeImgToUse = cl.url(photoUrlId, {
    gravity: 'center',
    height: 600,
    width: 900,
    crop: 'fill',
    format: 'jpg',
    quality: 80,
  })

  const email = getUserEmailFromCookies()
  const ipAddress = getUserIPAddressFromCookies()

  const options = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      data: {
        type: 'event',
        attributes: {
          properties: {
            MotorcycleId: bikeId,
            MotorcycleYear: year,
            MotorcycleMake: make,
            MotorcycleModel: model,
            MotorcycleCity: city,
            MotorcycleState: state,
            MotorcycleUrl: url,
            MotorcyclePhoto: bikeImgToUse,
            DailyRate: dailyPrice,
            OwnerName: ownerName,
          },
          metric: {data: {type: 'metric', attributes: {name: 'Motorcycle Viewed'}}},
          profile: {
            data: {
              type: 'profile',
              attributes: email ? {
                email: email
              } : {
                id: ipAddress
              }
            }
          }
        }
      }
    })
  }

  fetch(`https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_PUBLIC_API_KEY}`, options)
  .then(response => {
    console.log('klaviyo tracking trackBikePageViewed success', response)
  })
  .catch(err => {
    console.log('Failed to track trackBikePageViewed', err)
  })
}
